import { catalog, me } from '../api/endpoints.ts';
import type { RecentOrder, StorefrontItem } from '../api/types.ts';
import { currentLang, currentStrings } from '../i18n/index.ts';
import { currentScope } from './address-book.ts';
import { addAllToCart } from './cart.ts';
import { addWithChecks, describeChange } from './cart-sync.ts';
import { isSignedIn } from './session.ts';
import { notify } from './toasts.ts';

/** Товар витрины по идентификатору: товар, недоступный на складе адреса, не приходит. */
export async function lookupProduct(productId: string): Promise<StorefrontItem | null> {
  const items = await catalog.byIds([productId], currentScope(), currentLang()).catch(() => []);
  return items[0] ?? null;
}

/** Один товар с витрины склада адреса в корзину. `false` — там его больше не продают. */
export async function addProductById(productId: string): Promise<boolean> {
  const item = await lookupProduct(productId);
  if (!item) return false;
  addWithChecks(item);
  return true;
}

/**
 * Весь состав прошлого заказа в корзину со сверкой наличия. Оформление не начинается:
 * человек правит корзину и ходит по магазину дальше. `true` — добавлена хотя бы одна строка.
 */
export async function reorderAll(order: RecentOrder): Promise<boolean> {
  const strings = currentStrings();
  const items = await catalog.byIds(order.items.map((line) => line.productId), currentScope(), currentLang()).catch(() => []);
  const byId = new Map(items.map((item) => [item.id, item]));

  const toAdd: { item: StorefrontItem; qty: number }[] = [];
  const missing: string[] = [];
  for (const line of order.items) {
    const item = byId.get(line.productId);
    if (item) toAdd.push({ item, qty: line.qty });
    else missing.push(line.name);
  }

  for (const change of addAllToCart(toAdd)) notify(describeChange(change, strings));
  for (const name of missing) notify(`${name}: ${strings.itemGone}`);
  return toAdd.length > 0;
}

/** Самый свежий заказ вошедшего в корзину. `false` у гостя и без прошлых заказов. */
export async function repeatLastOrder(): Promise<boolean> {
  if (!isSignedIn()) return false;
  const last = (await me.recentOrders(1).catch(() => null))?.items[0];
  return last ? reorderAll(last) : false;
}
